import { requestGet } from '@/common/request';

export interface queryActivitiesParams {}

export interface queryActivitiesRes {
  ret: string;
  msg: string;
  data: Array<any>;
}

//会场运营 - 会场活动检索
export async function queryActivities(params: queryActivitiesParams): Promise<queryActivitiesRes> {
  return await requestGet('/room/queryActivities', params);
}
